import React from "react";

import TextInput from "../../../../components/formElements/input/TextInput";
import RadioButton from "../../../../components/formElements/radio-button/RadioButton";
import Card from "../../../../layout/Onboarding/Card";
import constants from "../../../../constants";
import Row from "../../../../components/uiElements/grid/Row";
import Col from "../../../../components/uiElements/grid/Col";
import CardLable from "../../../../components/formElements/label/CardLabel";

export const MedicationDetailsCard = ({
  personalPatientInfo,
  setPatientPersonalInfo,
  addCurrentMedicationTimes,
  addMedication,
  addMedicationTimes,
  removeMedication,
  setMedication,
  form,
}) => {
  return (
    <Card>
      <Row className="mt-4 mb-4">
        <Col>
          <CardLable
            name="Medication"
            condition={
              personalPatientInfo.current_medicine_name &&
              personalPatientInfo.current_medicine_timing &&
              personalPatientInfo.current_medicine_consumption_period.length >
                0 &&
              personalPatientInfo.current_dosage &&
              personalPatientInfo.current_instructions
            }
            onclick={() => addMedication()}
            labelName={
              personalPatientInfo.current_medicine_name &&
              personalPatientInfo.current_medicine_timing &&
              personalPatientInfo.current_medicine_consumption_period.length >
                0 &&
              personalPatientInfo.current_dosage &&
              personalPatientInfo.current_instructions
                ? "Add"
                : ""
            }
          />
        </Col>
        <Col className="mt-3 mb-n4">
          <TextInput
            id="current_medicine_name"
            // error={form.medicine_name}
            type="text"
            label="Medicine Name"
            value={personalPatientInfo.current_medicine_name}
            onChange={val =>
              setPatientPersonalInfo({ current_medicine_name: val })
            }
          />
          <div className="ml-n2 mb-5" style={{ marginTop: "-30px" }}>
            <RadioButton
              containerClassName="d-inline"
              label="Before Meal"
              value="BEFORE"
              name="medicine_timing"
              checked={personalPatientInfo.current_medicine_timing === "BEFORE"}
              onChange={val =>
                setPatientPersonalInfo({ current_medicine_timing: val })
              }
            />
            <RadioButton
              containerClassName=" d-inline"
              label="After Meal"
              value="AFTER"
              name="medicine_timing"
              checked={personalPatientInfo.current_medicine_timing === "AFTER"}
              onChange={val =>
                setPatientPersonalInfo({ current_medicine_timing: val })
              }
            />
          </div>
          <div className="mt-n4" style={{ marginBottom: "55px" }}>
            {constants.TIMINGS.map(day => (
              <div
                style={{
                  borderRadius: "5px",
                  border: "1px solid #E0E0E0",
                  height: "43px",
                  width: "80px",
                  display: "inline",
                  backgroundColor:
                    personalPatientInfo.current_medicine_consumption_period.includes(
                      day.value
                    )
                      ? "#F2F2F2"
                      : "#FFFFFF",
                  padding: "8px",
                  marginRight: "8px",
                  cursor: "pointer",
                  color: "#828282",
                }}
                onClick={() => addCurrentMedicationTimes(day.value)}
              >
                {day.label}
              </div>
            ))}
          </div>
          <TextInput
            id="current_dosage"
            // error={form.dosage}
            type="text"
            label="Dosage"
            value={personalPatientInfo.current_dosage}
            onChange={val => setPatientPersonalInfo({ current_dosage: val })}
          />
          <TextInput
            id="current_instructions"
            // error={form.instructions}
            type="text"
            label="Instructions"
            value={personalPatientInfo.current_instructions}
            onChange={val =>
              setPatientPersonalInfo({ current_instructions: val })
            }
          />
        </Col>
        {personalPatientInfo.medication_details !== null
          ? personalPatientInfo.medication_details.map((value, index) =>
              value.medicine_name === "" ? (
                ""
              ) : (
                <Col className="mt-5 mb-n4">
                  <Row>
                    <Col>
                      <CardLable
                        name={"Medication " + (index + 1)}
                        condition={null}
                        onclick={() => removeMedication(index)}
                        labelName="Remove"
                      />
                    </Col>
                    <Col className="mt-3 ">
                      <TextInput
                        id="medicine_name"
                        type="text"
                        label="Medicine Name"
                        value={value.medicine_name}
                        onChange={val =>
                          setMedication("medicine_name", val, index)
                        }
                      />
                      <div
                        className="ml-n2 mb-5"
                        style={{ marginTop: "-30px" }}
                      >
                        <RadioButton
                          containerClassName="d-inline"
                          label="Before Meal"
                          value="BEFORE"
                          name={"consumption" + index}
                          checked={value.consumption === "BEFORE"}
                          onChange={val =>
                            setMedication("consumption", val, index)
                          }
                        />
                        <RadioButton
                          containerClassName=" d-inline"
                          label="After Meal"
                          value="AFTER"
                          name={"consumption" + index}
                          checked={value.consumption === "AFTER"}
                          onChange={val =>
                            setMedication("consumption", val, index)
                          }
                        />
                      </div>
                      <div className="mt-n4" style={{ marginBottom: "55px" }}>
                        {constants.TIMINGS.map(day => (
                          <div
                            style={{
                              borderRadius: "5px",
                              border: "1px solid #E0E0E0",
                              height: "43px",
                              width: "80px",
                              display: "inline",
                              backgroundColor:
                                value.medicine_consumption_period.includes(
                                  day.value
                                )
                                  ? "#F2F2F2"
                                  : "#FFFFFF",
                              padding: "8px",
                              marginRight: "8px",
                              cursor: "pointer",
                              color: "#828282",
                            }}
                            onClick={() =>
                              addMedicationTimes(
                                "medicine_consumption_period",
                                day.value,
                                index
                              )
                            }
                          >
                            {day.label}
                          </div>
                        ))}
                      </div>
                      <TextInput
                        id="dosage"
                        type="text"
                        label="Dosage"
                        value={value.dosage}
                        onChange={val => setMedication("dosage", val, index)}
                      />
                      <TextInput
                        id="instruction"
                        type="text"
                        label="Instruction"
                        value={value.instruction}
                        onChange={val =>
                          setMedication("instruction", val, index)
                        }
                      />
                    </Col>
                  </Row>
                </Col>
              )
            )
          : ""}
      </Row>
    </Card>
  );
};
